/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatEventAdminAddedContentDto { 
    /**
     * id чата, в котором событие
     */
    chatId: string;
    /**
     * Наименование чата, в котором событие
     */
    chatName: string;
    /**
     * id добавленного пользователя администратором
     */
    userId: string;
    /**
     * Имя пользователя
     */
    userName: string;
    /**
     * Признак наличия у пользователя аватарки
     */
    isAvatarExists: boolean;
}

